import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import styled from 'styled-components';
import './App.css';
import { LocaleProvider } from './i18n/LocaleContext';
import { localizedRoutes } from './i18n/routes';

// Components
import Navbar from './components/Navbar';
import Footer from './components/Footer';

// Pages
import HomePage from './pages/HomePage';
import ContactPage from './pages/ContactPage';
import TermsAndPrivacyPage from './pages/TermsAndPrivacyPage';
import PaymentPage from './pages/PaymentPage';
import HowItWorksPage from './pages/HowItWorksPage';
import BlogIndexPage from './pages/BlogIndexPage';
import BlogPostPage from './pages/BlogPostPage';

// Context
import { NotificationProvider } from './context/NotificationContext';

const pageComponents = { home: HomePage, guide: HowItWorksPage, contact: ContactPage, legal: TermsAndPrivacyPage, pricing: PaymentPage };
const routes = localizedRoutes();

const AppShell = () => {
  const { pathname } = useLocation();
  const isBlogRoute = pathname.startsWith('/blog');

  return (
    <AppContainer>
      <ScrollToHash />
      {!isBlogRoute && <Navbar />}
      <main>
        <Routes>
          {routes.map(route => {
            const Page = pageComponents[route.page];
            return <Route key={route.path} path={route.path} element={<Page />} />;
          })}
          <Route path="/blog" element={<BlogIndexPage />} />
          <Route path="/blog/:slug" element={<BlogPostPage />} />
        </Routes>
      </main>
      {!isBlogRoute && <Footer />}
    </AppContainer>
  );
};

const ScrollToHash = () => {
  const { hash, pathname } = useLocation();

  useEffect(() => {
    if (!hash) {
      window.scrollTo(0, 0);
      return;
    }

    const id = hash.slice(1);
    const scroll = () => {
      const element = document.getElementById(id);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth', block: 'start' });
        return true;
      }
      return false;
    };

    if (scroll()) return;
    const timer = setTimeout(() => scroll(), 50);
    return () => clearTimeout(timer);
  }, [hash, pathname]);

  return null;
};

function App() {
  return (
    <NotificationProvider>
      <Router>
        <LocaleProvider><AppShell /></LocaleProvider>
      </Router>
    </NotificationProvider>
  );
}

const AppContainer = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100vh;

  main {
    flex: 1;
  }
`;

export default App;
